/*
  Drive Snapshot v9.8 (16.10.2026): Länder-Erkennung – Online-Bestellungen nur aus Deutschland und der EU.
  Daten aus snippets/ds-geo-check.liquid (#DsGeoConfig): erlaubte Länder (snippets/ds-allowed-countries, muss zu
  rules.allowed_countries im Lizenzdienst passen), Texte ds.geo.* mit [country]/[email]/[phone], Kontakt.
  Ablauf: GET /browsing_context_suggestions.json → detected_values.country.handle (ISO 3166-1 alpha-2).
  Land nicht erlaubt → Hinweis in alle [data-ds-geo-notice], Warenkorb: Kasse-Button ausgeblendet + disabled.
  FAIL-OPEN: Fehler, Zeitüberschreitung (4 s), kein/ungültiges Land → nichts ändern (Lizenzdienst bleibt die Sicherung).
*/
(function () {
  'use strict';
  var cfgEl = document.getElementById('DsGeoConfig');
  if (!cfgEl || !window.fetch) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.allowed || !cfg.allowed.length) return;
  var lang = String(cfg.lang || document.documentElement.lang || 'de').toLowerCase().slice(0, 2);

  // Ländernamen mit Artikel/Fall, damit „aus …“ / „from …“ grammatisch stimmt (sonst Intl.DisplayNames).
  var NAMES = {
    de: {
      AE: 'den Vereinigten Arabischen Emiraten', BS: 'den Bahamas', CD: 'der Demokratischen Republik Kongo',
      CF: 'der Zentralafrikanischen Republik', CG: 'der Republik Kongo', CH: 'der Schweiz', CI: 'der Elfenbeinküste',
      DO: 'der Dominikanischen Republik', FO: 'den Färöern', GB: 'dem Vereinigten Königreich', HK: 'Hongkong',
      IQ: 'dem Irak', IR: 'dem Iran', KM: 'den Komoren', KR: 'Südkorea', KY: 'den Kaimaninseln', LB: 'dem Libanon',
      MD: 'der Republik Moldau', MH: 'den Marshallinseln', MN: 'der Mongolei', MO: 'Macau', MV: 'den Malediven',
      NE: 'dem Niger', OM: 'dem Oman', PH: 'den Philippinen', PS: 'den Palästinensischen Gebieten', SB: 'den Salomonen',
      SC: 'den Seychellen', SD: 'dem Sudan', SN: 'dem Senegal', SS: 'dem Südsudan', TD: 'dem Tschad', TR: 'der Türkei',
      UA: 'der Ukraine', US: 'den USA', VA: 'der Vatikanstadt', VG: 'den Britischen Jungferninseln',
      VI: 'den Amerikanischen Jungferninseln', XK: 'dem Kosovo', YE: 'dem Jemen'
    },
    en: {
      AE: 'the United Arab Emirates', BS: 'the Bahamas', CD: 'the Democratic Republic of the Congo',
      CF: 'the Central African Republic', CG: 'the Republic of the Congo', DO: 'the Dominican Republic',
      FO: 'the Faroe Islands', GB: 'the United Kingdom', GM: 'the Gambia', HK: 'Hong Kong', KM: 'the Comoros',
      KR: 'South Korea', KY: 'the Cayman Islands', MH: 'the Marshall Islands', MO: 'Macao', MV: 'the Maldives',
      PH: 'the Philippines', PS: 'the Palestinian Territories', SB: 'the Solomon Islands', SC: 'the Seychelles',
      US: 'the United States', VA: 'Vatican City', VG: 'the British Virgin Islands', VI: 'the U.S. Virgin Islands'
    }
  };

  function countryName(code, fallback) {
    var map = NAMES[lang] || {};
    if (map[code]) return map[code];
    try {
      if (window.Intl && Intl.DisplayNames) {
        var name = new Intl.DisplayNames([lang], { type: 'region' }).of(code);
        if (name && name !== code) return name;
      }
    } catch (e) { /* Intl nicht verfügbar → Name aus der Antwort */ }
    return fallback ? String(fallback) : '';
  }

  // Text mit [country]/[email]/[phone] → DOM-Knoten (Textknoten + mailto-/tel-Link, kein HTML-String)
  function build(template, name) {
    var frag = document.createDocumentFragment();
    template.split(/(\[country\]|\[email\]|\[phone\])/).forEach(function (part) {
      if (part === '[country]') {
        frag.appendChild(document.createTextNode(name));
      } else if (part === '[email]' || part === '[phone]') {
        var a = document.createElement('a');
        a.className = 'ds-link';
        a.href = part === '[email]' ? 'mailto:' + cfg.email : 'tel:' + cfg.tel;
        a.textContent = part === '[email]' ? cfg.email : cfg.phone;
        frag.appendChild(a);
      } else if (part) {
        frag.appendChild(document.createTextNode(part));
      }
    });
    return frag;
  }

  function block(code, rawName) {
    var name = countryName(code, rawName);
    var template = name ? cfg.notice : cfg.noticeOther;
    if (!template) return;
    document.documentElement.setAttribute('data-ds-geo', 'blocked');
    var notices = document.querySelectorAll('[data-ds-geo-notice]');
    Array.prototype.forEach.call(notices, function (el, i) {
      if (i > 0) el.removeAttribute('role'); // nur eine Ansage je Seite
      var p = document.createElement('p');
      p.className = 'ds-geo__text';
      p.appendChild(build(template, name));
      el.textContent = '';
      el.appendChild(p);
      el.setAttribute('data-ds-geo-country', code);
    });
    // Warenkorb: Kasse-Button aus (Hinweis steht direkt darüber). „Anzahl aktualisieren“ und Entfernen bleiben nutzbar.
    Array.prototype.forEach.call(document.querySelectorAll('[data-ds-checkout]'), function (btn) {
      var form = btn.form || btn.closest('form');
      if (form) form.setAttribute('data-ds-geo-blocked', 'true');
      btn.disabled = true;
      btn.hidden = true;
      btn.setAttribute('aria-disabled', 'true');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ds-geo-hide]'), function (el) {
      el.hidden = true;
    });
  }

  // Zusätzliche Sperre gegen Absenden über name="checkout" (z. B. per Skript), solange gesperrt.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('data-ds-geo-blocked') !== 'true') return;
    var submitter = event.submitter || document.activeElement;
    if (submitter && submitter.name === 'checkout') event.preventDefault();
  }, true);

  var done = false;
  var ctrl = window.AbortController ? new AbortController() : null;
  var timer = setTimeout(function () {
    done = true;
    if (ctrl) ctrl.abort();
  }, 4000);

  fetch('/browsing_context_suggestions.json', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    signal: ctrl ? ctrl.signal : undefined
  })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      var c = data && data.detected_values && data.detected_values.country;
      var code = c && typeof c.handle === 'string' ? c.handle.trim().toUpperCase() : '';
      if (!/^[A-Z]{2}$/.test(code)) return; // kein Land → fail-open
      if (cfg.allowed.indexOf(code) !== -1) return;
      block(code, c.name);
    })
    .catch(function () {
      done = true;
      clearTimeout(timer); // fail-open
    });
})();
